var _circle, _circle2, _circle3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalP2IconTree3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 32,
    stroke: "#D41E4D",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 19,
    stroke: "#D41E4D",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 7,
    stroke: "#D41E4D",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 72.0003L40.5 43.0003L40.3281 40L43.3284 40.1719L72.3284 69.1719L69.5 72.0003Z",
    fill: "#D41E4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.864 75.3845L63.5104 63.0101L75.8848 63.3637",
    stroke: "#D41E4D",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalP2IconTree3);
export default __webpack_public_path__ + "static/media/Digital_P2_Icon_Tree3.06409f80b530cd15457074289bba3799.svg";
export { ForwardRef as ReactComponent };